<div [ngClass]="{'light-theme': !isDarkTheme, 'dark-theme': isDarkTheme }">
  <router-outlet ></router-outlet>
</div>
<div class="overlay flex-center vh-100" *ngIf="loading$ | async">
	<cube-spinner></cube-spinner>
</div>